import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { Button } from "@mantine/core";
import { mediaUrl } from "@/lib/config/app";
import PureHtml from "../custom/PureHtml";
export default function SideImage(t0) {
  const $ = _c(17);
  const {
    simage
  } = t0;
  const imageAlt = simage?.image_alt || simage?.heading || "Side Banner";
  const t1 = simage?.heading;
  let t2;
  if ($[0] !== t1) {
    t2 = <h2 className="text-xl lg:text-2xl mb-2">{t1}</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = simage?.subtext;
  let t4;
  if ($[2] !== t3) {
    t4 = <PureHtml html={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== simage?.button_link || $[5] !== simage?.button_text) {
    t5 = simage?.button_text && <Link href={simage?.button_link}><Button size="lg" autoContrast={true} color="var(--color-secondary)" ff="Fjalla One" fw={400} miw={175}>{simage?.button_text}</Button></Link>;
    $[4] = simage?.button_link;
    $[5] = simage?.button_text;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div className="shadow p-2 lg:p-4 bg-white rounded">{t2}{t4}{t5}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== imageAlt || $[12] !== simage) {
    t7 = <div className="text-center">{simage?.image_url ? <Image src={`${mediaUrl}${simage.image_url}`} alt={imageAlt} width={700} height={500} sizes="(max-width: 768px) 100vw, 50vw" className="w-full h-auto rounded" /> : <Image src="/img/elf-bar-plus-50.png" alt={imageAlt} width={350} height={250} sizes="(max-width: 768px) 100vw, 50vw" className="h-full w-full" />}</div>;
    $[11] = imageAlt;
    $[12] = simage;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <section className="side-image py-2 lg:py-3"><div className="max-w-7xl mx-auto px-2"><div className="grid grid-cols-1 lg:grid-cols-2 items-center justify-center gap-2">{t6}{t7}</div></div></section>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}